import antisocialApeClubIcon from './media/antisocial-ape-club.jpg';
import apollo42Icon from './media/apollo42.jpg';
import arbitoorAggregatorIcon from './media/arbitoor-aggregator.jpg';
import armoredKingdomIcon from './media/armored-kingdom.jpg';
import astroStakersIcon from './media/astro-stakers.jpg';
import astrodaoIcon from './media/astrodao.jpg'; 
import burrowIcon from './media/burrow.svg';
import collectNFTsSectionIcon from './media/collectNFTsSectionIcon.svg';
import cryptoheroeIcon from './media/cryptoheroes.jpg';
import dragonflyCapitalPartnersIcon from './media/dragonfly-capital-partners.svg';
import exchangeSectionIcon from './media/exchangeSectionIcon.svg';
import galaxyOnlineIcon from './media/galaxy-online.svg';
import hashRushIcon from './media/hash-rush.png';
import jumboExchangeIcon from './media/jumbo-exchange.jpg';
import linearProtocolIcon from './media/linear-protocol.jpg';
import metapoolIcon from './media/meta-pool.jpg';
import metamonIcon from './media/metamon.jpg';
import mintbaseIcon from './media/mintbase.jpg';
import nearnautsIcon from './media/nearnauts.jpg';
import parasIcon from './media/paras.svg';
import pembrockFinanceIcon from './media/pembrock-finance.jpg';
import playToEarnSectionIcon from './media/playToEarnSectionIcon.svg';
import rainbowbridgeIcon from './media/rainbow-bridge.svg';
import refFinanceIcon from './media/ref-finance.jpg';
import spinIcon from './media/spin.jpg';
import startEarningSectionIcon from './media/startEarningSectionIcon.svg';
import sweatEconomyIcon from './media/sweat-economy.jpg';
import tamagoIcon from './media/tamago.jpg';
import tonicDexIcon from './media/tonic-dex.jpg';


export const trandingProjects = [
    {
        icon: refFinanceIcon,
        name: 'Ref Finance',
        linkName: 'ref-finance'
    },
    {
        icon: parasIcon,
        name: 'Paras',
        linkName: 'paras'
    },
    {
        icon: burrowIcon,
        name: 'Burrow',
        linkName: 'burrow'
    },
    {
        icon: metapoolIcon,
        name: 'Meta Pool',
        linkName: 'meta-pool'
    },
    {
        icon: astrodaoIcon,
        name: 'Astro DAO',
        linkName: 'astrodao'
    },
    {
        icon: rainbowbridgeIcon,
        name: 'Rainbow Bridge',
        linkName: 'rainbow-bridge'
    }
];

export const exchangeSection = {
    name: 'Exchanges',
    icon: exchangeSectionIcon,
    colour: '#FFF7FB',
    sectionLink: 'exchanges',
    projects: [
        {
            icon: refFinanceIcon,
            name: 'Ref Finance',
            linkName: 'ref-finance',
            category: 'AMM DEX',
            info: 'Multi-purpose DeFi platform built on NEAR Protocol.'
        },
        {
            icon: tonicDexIcon,
            name: 'Tonic DEX',
            linkName: 'tonic-dex',
            category: 'Orderbook DEX',
            info: 'Orderbook DEX on NEAR.'
        },
        {
            icon: jumboExchangeIcon,
            name: 'Jumbo Exchange',
            linkName: 'jumbo-exchange',
            category: 'AMM DEX',
            info: 'UI/UX Friendly AMM built on NEAR.'
        },
        {
            icon: arbitoorAggregatorIcon,
            name: 'Arbitoor Aggregator',
            linkName: 'arbitoor-aggregator',
            category: 'DEX Aggregator',
            info: 'The Liquidity Aggregator and Swap Infrastructure for NEAR.'
        },
        {
            icon: spinIcon,
            name: 'Spin',
            linkName: 'spin',
            category: 'Orderbook DEX',
            info: 'DeFi derivatives infrastructure built on NEAR Protocol.'
        },
        {
            icon: rainbowbridgeIcon,
            name: 'Rainbow Bridge',
            linkName: 'rainbow-bridge',
            category: 'Cross-chain Bridge',
            info: 'Transfer tokens between Ethereum and NEAR.'
        },
    ]
};

export const startEarningSection = {
    name: 'Start Earning',
    icon: startEarningSectionIcon,
    colour: 'linear-gradient(0deg, #F4FFEE, #F4FFEE), linear-gradient(0deg, #ECFFE3, #ECFFE3), linear-gradient(0deg, #ECFFE3, #ECFFE3), #ECFFE3;',
    sectionLink: 'defi',
    projects: [
        {
            icon: burrowIcon,
            name: 'Burrow',
            linkName: 'burrow',
            category: 'Lending Protocol',
            info: 'Borrow, Supply, Thrive.'
        },

        {
            icon: pembrockFinanceIcon,
            name: 'PembRock Finance',
            linkName: 'pembrock-finance',
            category: 'Leveraged yield farming',
            info: 'Leveraged yield farming on NEAR.'
        },
        {
            icon: metapoolIcon,
            name: 'Meta Pool',
            linkName: 'meta-pool',
            category: 'Liquid Staking',
            info: 'Liquid Staking Protocol built on NEAR.'
        },
        {
            icon: linearProtocolIcon,
            name: 'LiNEAR Protocol',
            linkName: 'linear-protocol',
            category: 'Liquid Staking',
            info: 'Your Journey of DeFi on NEAR Starts Here.'
        },
        {
            icon: astroStakersIcon,
            name: 'Astro-Stakers',
            linkName: 'astro-stakers',
            category: 'Staking Provider',
            info: 'Low-fee Community Staking Provider for NEAR Protocol.'
        },
        {
            icon: dragonflyCapitalPartnersIcon,
            name: 'Dragonfly Capital Partners',
            linkName: 'dragonfly-capital-partners',
            category: 'Staking Provider',
            info: 'Global from day one.'
        },
    ]
};

export const collectNFTsSection = {
    name: 'Collect NFTs',
    icon: collectNFTsSectionIcon,
    colour: 'linear-gradient(0deg, #FEF4FF, #FEF4FF), linear-gradient(0deg, #ECFFE3, #ECFFE3), linear-gradient(0deg, #ECFFE3, #ECFFE3), #ECFFE3;',
    sectionLink: 'marketplaces',
    projects: [
        {
            icon: parasIcon,
            name: 'Paras',
            linkName: 'paras',
            category: 'NFT Marketplace',
            info: 'Create, Trade, and Collect Digital Collectibles.'
        },
        {
            icon: mintbaseIcon,
            name: 'Mintbase',
            linkName: 'mintbase',
            category: 'NFT Marketplace',
            info: 'Digital assets minted and backed by you.'
        },
        {
            icon: apollo42Icon,
            name: 'Apollo42',
            linkName: 'apollo42',
            category: 'NFT Marketplace',
            info: 'Your journey to a new galaxy of digital cultures and collectibles.'
        },
        {
            icon: tamagoIcon,
            name: 'Tamago',
            linkName: 'tamago',
            category: 'Audio Streaming platform',
            info: 'Decentralized Audio Streaming platform built on the NEAR.'
        },
        {
            icon: nearnautsIcon,
            name: 'NEARNauts',
            linkName: 'nearnauts',
            category: 'NFT Collectibles',
            info: 'A generative project on the NEAR Network.'
        },
        {
            icon: antisocialApeClubIcon,
            name: 'Antisocial Ape Club',
            linkName: 'antisocial-ape-club',
            category: 'NFT Collectibles',
            info: '3333 unique, randomly generated pixel art ape NFTs.'
        },
    ]
};

export const playToEarnSection = {
    name: 'Play To Earn',
    icon: playToEarnSectionIcon,
    colour: 'linear-gradient(0deg, #F7F7FF, #F7F7FF), linear-gradient(0deg, #ECFFE3, #ECFFE3), linear-gradient(0deg, #ECFFE3, #ECFFE3), #ECFFE3;',
    sectionLink: 'gaming',
    projects: [
        {
            icon: metamonIcon,
            name: 'Metamon',
            linkName: 'metamon',
            category: 'Play to Earn',
            info: 'Free-to-play Play-to-Earn online Battle Royale Game and Sci-Fi Franchise.'
        },
        {
            icon: cryptoheroeIcon,
            name: 'Crypto Hero',
            linkName: 'cryptoheroes',
            category: 'Play to Earn',
            info: 'A blockchain game focused on PvE with a P2E raid system.'
        },
        {
            icon: armoredKingdomIcon,
            name: 'Armored Kindom',
            linkName: 'armored-kingdom',
            category: 'Play to Earn',
            info: 'A multi-media entertainment universe.'
        },
        {
            icon: galaxyOnlineIcon,
            name: 'Galaxy Online',
            linkName: 'galaxy-online',
            category: 'Play to Earn',
            info: 'Epic MMO with blockchain-based game races.'
        },
        {
            icon: hashRushIcon,
            name: 'Hash Rush',
            linkName: 'hash-rush',
            category: 'Play to Earn',
            info: 'Online sci-fi/fantasy RTS set in the fictional Hermeian galaxy.'
        },
        {
            icon: sweatEconomyIcon,
            name: 'Sweat Economy',
            linkName: 'sweat-economy',
            category: 'Move to Earn',
            info: 'Sweatcoin. Move to Earn. Walk into crypto.'
        }
    ]
};
